import * as React from "react";
import { Goal } from "@curefit/gmf-common";
import CustomHeader, {ICustomHeaderInfo} from "../../utils/CustomHeader";
import TemplatedList from "../../TemplatedList";
import ModelFactory from "../../../models/ModelFactory";
import IMetric from "../../../models/metrics/IMetric";

const GoalEditorHeaderInfos: ICustomHeaderInfo[] = [
    {label: "goalName", display: "Goal"},
    {label: "metric", display: "Metric"},
    {label: "current", display: "Current"},
    {label: "target", display: "Target"}
];

export interface LCGoalEditorProps {
    updatedGoals: any[],
    staticGoals: Goal,
    staticMetrics: IMetric,
    updateGoals: (updatedGoals: {item: any}[]) => void
}

export class LCGoalEditor extends React.Component<LCGoalEditorProps> {

    getCommonProps = () => {
        return {
            staticGoals: this.props.staticGoals,
            staticMetrics: this.props.staticMetrics
        }
    }

    onGoalRemove = (index: number) => {
        let currUpdatedGoals = Object.assign([], this.props.updatedGoals);
        currUpdatedGoals.splice(index, 1);
        this.props.updateGoals(currUpdatedGoals);
    }

    onGoalChange = (updatedGoal: any, index: number) => {
        let currUpdatedGoals = Object.assign([], this.props.updatedGoals);
        currUpdatedGoals[index] = updatedGoal;
        this.props.updateGoals(currUpdatedGoals);
    }

    render() {
        return (
            <div className={"lc-goal-editor"}>
                <CustomHeader headerInfos={GoalEditorHeaderInfos} rootCls={"lc-goal"}/>
                <TemplatedList
                    templateName={"lcGoalItemEditor"}
                    defaultItem={{item: ModelFactory.createNewGoalItem()}}
                    listItems={this.props.updatedGoals || []}
                    id={""}
                    commonProps={this.getCommonProps()}
                    autoAddNewRow={true}
                    onItemChange={this.onGoalChange}
                    onItemRemove={this.onGoalRemove}
                />
            </div>
        )
    }
}